import React, { useEffect, useState, memo } from "react";
import { Table as BootstrapTable } from "react-bootstrap";
import { getUserInfoDetailsByUserId } from "../../../store/slices/userSlice";
import { useSelector, useDispatch } from "react-redux";
import HeaderSection from "./HeaderSection/HeaderSection";
import TableHead from "./TableHead/TableHead";
import TableBody from "./TableBody/TableBody";
// import InfiniteScroll from "../InfiniteScroll/InfiniteScroll";
import Pagination from "../pagination/pagination";
const Table = ({
  tableHead,
  showPaymentStatusTab,
  tableBody,
  addModal,
  handleSearch,
  handleEdit,
  handleDelete,
  handleShowGlobalViewModal,
  handlePermission,
  errorMessage,
  searchValue,
  setBulkUploadModal,
  handleExportData,
  handleUpdateStatus,
  showStatus,
  setShowStatus,
  handleAddBtn,
  filterDateForSearch,
  redirectReferrerPaymentPage,
  handleCheckboxChange,
  handleCheckAllBox,
  checkedItems,
  isCheckAll,
  handleSorting,
  handlePrint,
  showPrintButton,
  handleShare,
  hideStatusTab,
  payemntHeaderColor,
  handelProfile,
  handleRefund,
  handleCancel,
  disableRowClick = false,
  showPagination = false,
  showLimitDropdown = false,
  currentPage,
  totalPages,
  totalCount,
  limit,
  onLimitChange,
  onPageChange,
  isLoading,
}) => {
  const [errorMsg, setErrorMsg] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { userInfoDetails } = useSelector((state) => state.users);
  const userId = userInfo?._id;

  const userType = Number(sessionStorage.getItem("userType"));

  useEffect(() => {
    if (userId) {
      dispatch(
        getUserInfoDetailsByUserId({
          userId,
          token,
          userType,
          applicationId: 2,
        }),
      );
    }
  }, [dispatch, userId, token, userType]);

  useEffect(() => {
    if (
      (searchValue?.length > 0 || filterDateForSearch?.length > 0) &&
      (tableBody?.length < 1 || !tableBody)
    ) {
      setErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
  }, [searchValue, tableBody, filterDateForSearch]);

  const toggleStatus = (index) => {
    setShowStatus && setShowStatus(showStatus === index ? null : index);
  };

  const handleStatusSelect = (status, item) => {
    handleUpdateStatus(status, item);
    setShowStatus(null);
  };

  const getModulePermission = (moduleTitle, modules) => {
    const module = modules?.find(
      (module) =>
        module?.parentModule?.pageUrl?.toLowerCase() ===
        moduleTitle?.toLowerCase(),
    );
    if (module) return module;
    for (const module of modules) {
      if (module?.childModules) {
        const childModule = module?.childModules?.find(
          (child) =>
            child?.pageUrl?.toLowerCase() === moduleTitle?.toLowerCase(),
        );
        if (childModule) return childModule;
        if (childModule?.subChildModules) {
          const subChildModule = childModule?.subChildModules?.find(
            (subChild) =>
              subChild?.pageUrl?.toLowerCase() === moduleTitle?.toLowerCase(),
          );
          if (subChildModule) return subChildModule;
        }
      }
    }
    return null;
  };

  let path = window.location.pathname;
  path = path.split("/");
  const currentModuleTitle = path[path.length - 1];
  const currentModulePermission = getModulePermission(
    currentModuleTitle,
    userInfoDetails,
  );

  const canView = currentModulePermission?.canView;
  const canEdit = currentModulePermission?.canEdit;
  const canAdd = currentModulePermission?.canAdd;
  const canDelete = currentModulePermission?.canDelete;
  const canExport = currentModulePermission?.canExport;

  return (
    <>
      <HeaderSection
        canAdd={canAdd}
        handleAddBtn={handleAddBtn}
        canExport={canExport}
        handleExportData={handleExportData}
        searchValue={searchValue}
        handleSearch={handleSearch}
        addModal={addModal}
        setBulkUploadModal={setBulkUploadModal}
        showPaymentStatusTab={showPaymentStatusTab}
        hideStatusTab={hideStatusTab}
        limit={limit}
        onLimitChange={onLimitChange}
        showLimitDropdown={showLimitDropdown}
      />
      {/* <InfiniteScroll
        data={tableBody || []}
        fetchMore={fetchMoreData}
        hasMore={hasMore}
      > */}
      <div className="row w-100">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <BootstrapTable responsive>
                  <TableHead
                    tableHead={tableHead}
                    handleCheckAllBox={handleCheckAllBox}
                    isCheckAll={isCheckAll}
                    tableBody={tableBody}
                    handleShowGlobalViewModal={handleShowGlobalViewModal}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handlePermission={handlePermission}
                    redirectReferrerPaymentPage={redirectReferrerPaymentPage}
                    handleSorting={handleSorting}
                    payemntHeaderColor={payemntHeaderColor}
                    handleCancel={handleCancel}
                  />
                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td
                          colSpan={tableHead?.length || 10}
                          className="text-center align-middle"
                          style={{ height: "200px" }}
                        >
                          <div className="d-flex flex-column justify-content-center align-items-center h-100">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            />
                            <p className="mt-2 mb-0">Loading data...</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <>
                      <TableBody
                        tableBody={tableBody}
                        tableHead={tableHead}
                        canView={canView}
                        handleShowGlobalViewModal={handleShowGlobalViewModal}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handlePermission={handlePermission}
                        handleCheckboxChange={handleCheckboxChange}
                        checkedItems={checkedItems}
                        handleStatusSelect={handleStatusSelect}
                        showStatus={showStatus}
                        toggleStatus={toggleStatus}
                        redirectReferrerPaymentPage={
                          redirectReferrerPaymentPage
                        }
                        canEdit={canEdit}
                        canDelete={canDelete}
                        canExport={canExport}
                        handlePrint={handlePrint}
                        handleShare={handleShare}
                        handelProfile={handelProfile}
                        handleRefund={handleRefund}
                        handleCancel={handleCancel}
                        showPrintButton={showPrintButton}
                        disableRowClick={disableRowClick}
                      />
                    </>
                  )}
                </BootstrapTable>
                {(!tableBody || tableBody.length === 0) &&
                  searchValue?.length <= 0 && (
                    <h5 className="text-center">No Data Found.</h5>
                  )}

                {errorMsg && (
                  <h5 className="text-center" role="alert">
                    {errorMessage}
                  </h5>
                )}
                {showPagination && !isLoading && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages || 1}
                    totalCount={totalCount || 0}
                    limit={limit}
                    onPageChange={onPageChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </InfiniteScroll> */}
    </>
  );
};

export default memo(Table);
